const COMMENTS = [
  {
    name: '漫画迷小李',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20manga%20style%20avatar%20portrait%20of%20young%20person%20with%20warm%20smile%2C%20simple%20clean%20background%2C%20digital%20illustration%2C%20friendly%20approachable%20vibe&width=120&height=120&seq=avatar-01&orientation=squarish',
    date: '2026年7月28日',
    content: '虫虫漫画网真的太好用了！下拉式阅读体验超棒，再也不用一直点翻页了。韩漫资源特别全，追了好久的总裁漫画这里都有最新话，强烈推荐！',
    rating: 5,
  },
  {
    name: '深夜追漫人',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20avatar%20portrait%20with%20cool%20expression%2C%20dark%20hair%2C%20simple%20clean%20background%2C%20digital%20illustration%2C%20modern%20manga%20aesthetic&width=120&height=120&seq=avatar-02&orientation=squarish',
    date: '2026年7月27日',
    content: '从贴吧追过来的老读者了，用了两年虫虫漫画网，更新速度是真的快。国漫区的作品质量越来越高了，狐妖大人那部从第一话追到现在，陪伴了我无数个深夜。',
    rating: 5,
  },
  {
    name: '甜甜圈不加糖',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20kawaii%20style%20avatar%20portrait%20of%20girl%20with%20pink%20hair%2C%20happy%20expression%2C%20simple%20clean%20background%2C%20digital%20illustration%2C%20cute%20manga%20aesthetic&width=120&height=120&seq=avatar-03&orientation=squarish',
    date: '2026年7月26日',
    content: '闺蜜安利来的，从此入坑爬不出来了！日漫和BL分类做得很细致，找漫画很方便。APP的夜间模式对熬夜看漫画的我来说太友好了，推荐所有爱看免费漫画的朋友都来试试！',
    rating: 5,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            读者评论
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            看看读者们对<strong>虫虫漫画网</strong>的真实评价
          </p>
        </div>
        <div className="max-w-3xl mx-auto grid gap-4">
          {COMMENTS.map((comment) => (
            <div
              key={comment.name}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900">{comment.name}</h3>
                  <div className="flex items-center gap-1 mt-0.5">
                    {Array.from({ length: comment.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-400 text-xs"></i>
                    ))}
                    <span className="text-xs text-foreground-500 ml-2">{comment.date}</span>
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}